var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9627 10C2.9627 10 -1.47208 9.02467 0.509971 4.18267C0.509971 4.18267 0.959982 4.72067 0.897981 4.98267C0.897981 4.98267 1.25066 3.76067 2.01201 3.03067C2.66669 2.4 3.33337 0.637333 2.71736 0C2.71736 0 5.7521 0.637333 6.09011 3.82467C6.09011 3.82467 6.47812 2.80933 7.2748 2.70867C7.2748 2.70867 7.03013 3.26667 7.2748 4.104C7.2748 4.104 9.7882 8.406 5.45676 9.86067C5.45676 9.86067 6.75546 8.386 4.00139 5.856C4.00139 5.856 3.35204 7.21067 2.96403 7.68867C2.9627 7.69 1.87934 8.904 2.9627 10Z",
    fill: "#F63C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b28190bc414eadb91a3748bd25bfbc65.svg";
export { ForwardRef as ReactComponent };